import { AXIS_HIGH_UNBOUNDED_NUMBER, AXIS_LOW_UNBOUNDED_NUMBER } from './constants';

export const formatValueIfUnbounded = (value: number | string) => {
  if (typeof value === 'number') {
    if (
      value === AXIS_HIGH_UNBOUNDED_NUMBER
      || value === AXIS_LOW_UNBOUNDED_NUMBER
    ) {
      return 'unbounded';
    }
  }
  return value;
};
